
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import api from "@/api";
import { createTableTree } from "@/utils/tree";
import { DepartmentDto } from "@/api/appService";

@Component
export default class DepartmentSelect extends Vue {
  @Prop({ required: false, default: true }) single!: boolean;

  @Prop({ required: false, default: "暂时不加入部门" }) closeText!: string;

  public show: boolean = false;

  queryForm: any = { keyword: undefined };

  title = "选择加入部门";

  tableData: any = {
    items: [],
    pagesize: 10,
    page: 1,
    sorting: "id asc",
    totalCount: 0
  };

  tableItems: any[] = [];

  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      // 打开
      this.getAll();
    } else {
      this.queryForm.keyword = undefined;
    }
  }

  async getAll() {
    await api.department.getAll({}).then(res => {
      const tree = createTableTree(
        res.items!,
        "parentId",
        "id",
        null,
        "children"
      );
      console.log(tree);
      this.tableItems = tree;
    });
  }

  async handleSearch() {
    this.getAll();
  }

  async select(item: DepartmentDto) {
    this.$emit("select", item);
    this.show = false;
  }

  async notJoin() {
    this.$emit("select", { id: undefined });
    this.show = false;
  }

  async submit() {}
}
